module.exports = __webpack_public_path__ + "img/characterAnimationHover.1b4c69eb.png";